import React from 'react';
import { LevelSection } from '../components/units/LevelSection';
import { ApprenticeSelector } from '../components/apprentices/ApprenticeSelector';
import { buildLevels } from '../lib/helpers';

export function UnitProgressPage({ profile, evidence, myApprentices, selApprId, setSelApprId, units, trainingPlans, signoffs, workplaceSignoffs, knowledgeUnits, levelDates, onSaveLevelDate, onToggleSignoff, onToggleWorkplace, onToggleKnowledge }) {
  const activeId = profile.role === 'apprentice' ? profile.id : selApprId;
  const plan = trainingPlans.filter(p => p.apprentice_id === activeId);
  const levels = buildLevels(units, plan);

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Unit Progress</div>
          <div className="page-sub">Track completion by year level</div>
        </div>
      </div>

      {profile.role !== 'apprentice' && (
        <ApprenticeSelector apprentices={myApprentices} active={selApprId} onChange={setSelApprId} />
      )}

      {plan.length === 0 ? (
        <div className="empty">
          <div className="empty-icon">📐</div>
          <p>No training plan loaded yet</p>
          <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 6 }}>
            {profile.role === 'apprentice'
              ? 'Your employer or trainer needs to import your training plan.'
              : 'Go to Bulk Upload → Smart PDF Import to load a training plan from your RTO.'}
          </p>
        </div>
      ) : (
        levels.map(level => (
        <LevelSection
          key={level.year}
          level={level}
          apprenticeId={activeId}
          levelDates={levelDates}
          evidence={evidence}
          signoffs={signoffs}
          workplaceSignoffs={workplaceSignoffs}
          knowledgeUnits={knowledgeUnits}
          profile={profile}
          onSaveLevelDate={onSaveLevelDate}
          onToggleSignoff={onToggleSignoff}
          onToggleWorkplace={onToggleWorkplace}
          onToggleKnowledge={onToggleKnowledge}
        />
      ))
      )}
    </div>
  );
}
